<template>
  <VStockGridItemLayout v-bind="item" :has-any-promo="grid.hasAnyPromo">
    <template #name>
      <!-- #D486 -->
      {{ item.name }}
    </template>

    <template #sub-name>
      {{ $t('internalstock.subscription_instance_headline') }}
      <!-- #S857 -->
    </template>

    <template #small="{ promotionEnd, promotionType }">
      <!-- #S822 -->
      <template v-if="promotionEnd">
        <template v-if="promotionType === 1">
          {{ $t('internalstock.ongoing_optin_promotion_information') }}
        </template>
        <template v-else-if="promotionType === 2">
          {{ $t('internalstock.ongoing_optout_promotion_information') }}
        </template>
      </template>
    </template>

    <template #minimumCommitmentPeriod="{ minimumCommitmentPeriodFactor, minimumCommitmentPeriodUnit }">
      <dt><!-- #S823 -->{{ $t('common.minimum_contract_period_label') }}</dt>
      <dd>
        <VMinimumCommitmentPeriod :factor="minimumCommitmentPeriodFactor" :unit="minimumCommitmentPeriodUnit" />
      </dd>
    </template>

    <template #bookingPeriod="{ start, end }">
      <VBookingPeriod :start="start" :end="end" />
    </template>

    <template #promotionPeriod="{ start, promotionEnd }">
      <VPromotionPeriod :start="start" :promotion-end="promotionEnd" />
    </template>

    <template #state="instance">
      <VStateIcon v-bind="instance" />
    </template>

    <template #buttons>
      <button class="btn btn-small btn-default" :disabled="grid.isBusy" @click="onConfirmation(item.id, 'resetPromotion')">
        {{ $t('internalstock.resetPromotion_button_label') }}
        <!-- #S826 -->
      </button>
    </template>

    <template #confirm>
      <VConfirmation :id="item.id" v-model="grid.confirmation" :heading="actionHeadline" :is-busy="grid.isBusy" class="row" @confirm="onConfirmSubscription">
        <template #prompt>
          <!-- #S854 -->
          {{ $t('internalstock.resetPromotion_prompt') }}
        </template>
        <template #success>
          <!-- #S873 -->
          {{ $t('internalstock.resetPromotion_successful_information') }}
        </template>
      </VConfirmation>
    </template>

    <template #details="instance">
      <VDetails v-bind="instance" :item="item" @confirm="onConfirmInstance" />
    </template>
  </VStockGridItemLayout>
</template>

<script>
import Proxy from '@/proxies/SubstoreInternalStockProxy';
import VStockGridItemLayout from '@/components/Substore/StockGrid/ItemLayout';
import VBookingPeriod from './BookingPeriod';
import VPromotionPeriod from './PromotionPeriod';
import VStateIcon from './StateIcon';
import VMinimumCommitmentPeriod from './MinimumCommitmentPeriod';
import VConfirmation from '@/components/Confirmation';
import { getLegacyErrorMessage } from '@/utils/i18n';

export default {
  name: 'InternalStockItem',

  components: {
    VStockGridItemLayout,
    VBookingPeriod,
    VPromotionPeriod,
    VStateIcon,
    VMinimumCommitmentPeriod,
    VConfirmation,
    VDetails: () => import('./Details'),
  },

  inject: {
    grid: {
      from: 'grid',
      default: {},
    },
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    actionHeadline() {
      return this.grid.confirmation?.headline;
    },
  },

  methods: {
    onConfirmation(subscriptionTemplateId, action) {
      this.grid.confirmation = { id: subscriptionTemplateId, subscriptionTemplateId, action, headline: `internalstock.${action}_button_label` };
    },

    async onConfirmSubscription({ subscriptionTemplateId, action }) {
      this.grid.isBusy = true;
      try {
        await new Proxy().actionSubscription({ subscriptionTemplateId, action });
        this.grid.confirmation = Object.assign({}, this.grid.confirmation, {
          message: {
            type: 'SUCCESS',
          },
        });
      } catch (e) {
        this.grid.confirmation = Object.assign({}, this.grid.confirmation, {
          message: {
            type: 'ERROR',
            supplier: () => getLegacyErrorMessage(e),
          },
        });
      } finally {
        this.grid.isBusy = false;
      }
    },

    async onConfirmInstance({ uniqueSubscriptionId, action }) {
      this.grid.isBusy = true;
      try {
        const response = await new Proxy().actionInstance({ uniqueSubscriptionId, action });
        this.grid.$emit('update:instance', response.data.instance);
        this.grid.confirmation = Object.assign({}, this.grid.confirmation, {
          message: {
            type: 'SUCCESS',
          },
        });
      } catch (e) {
        this.grid.confirmation = Object.assign({}, this.grid.confirmation, {
          message: {
            type: 'ERROR',
            supplier: () => getLegacyErrorMessage(e),
          },
        });
      } finally {
        this.grid.isBusy = false;
      }
    },
  },
};
</script>
